import React from "react";

function Lobby() {
  return <div>Lobby</div>;
}

export default Lobby;
